export default __webpack_public_path__ + "static/media/poster8.1d626934.png";